import React, { useCallback } from 'react';
import styled from 'styled-components';
const StyledContainer = styled.div `
  display: flex;
  align-items: center;
  min-height: 4rem;
  padding: 0.666666667rem 0;
  border-bottom: 2px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
  box-sizing: border-box;
`;
const TableRow = ({ children, className, data = {}, style, onClick = () => { }, }) => {
    const handleClick = useCallback(() => {
        onClick(data);
    }, [data, onClick]);
    return (React.createElement(StyledContainer, { className: className, onClick: handleClick, style: style }, children));
};
export default TableRow;
